import moment from 'moment';
import {Constants} from "./Constants";

export let DateUtility = {
    momentToLocalMoment: function (momentIn: moment.Moment) {
        return momentIn.local();
    },

    momentToDisplayDate: function (momentIn: moment.Moment) {
        return momentIn.format('MM/DD/YYYY');
    },

    dbDateToTimestamp: function (inputDate: string) {
        return DateUtility.dbDateToMoment(inputDate)?.unix()
    },

    dbDateToMoment: function (inputDate?: string) {
        if (inputDate) {
            return moment.utc(inputDate.replace('Z', ''), 'YYYY-MM-DDTHH:mm:ss.SSS');
        } else {
            return undefined;
        }
    },

    dbDateToLocalMoment: function (inputDate?: string) {
        if (inputDate) {
            return this.dbDateToMoment(inputDate)?.local();
        } else {
            return undefined;
        }
    },

    dbDateToLocalDisplayDate: function (inputDate?: string) {
        if (inputDate) {
            return DateUtility.momentToDisplayDate(DateUtility.dbDateToLocalMoment(inputDate) as moment.Moment)
        } else {
            return undefined;
        }
    },

    currentJsDate: function () {
        return moment().toDate()
    },

    jsDateToUnixTimestamp: function (jsDate: Date) {
        return moment(jsDate).unix()
    },

    jsDateToMoment: function (jsDate: Date) {
        return moment(jsDate)
    },

    jsDateToURLDate: function (jsDate: Date) {
        return DateUtility.jsDateToMoment(jsDate).format('YYYY-MM-DD')
    },

    urlDateToJsDate: function (urlDate: string) {
        return DateUtility.urlDateToMoment(urlDate).toDate()
    },

    urlDateToMoment: function (urlDate: string) {
        return moment(urlDate, 'YYYY-MM-DD')
    },

    dbDateToDisplayTime: function (dateString: string) {
        return DateUtility.dbDateToLocalMoment(dateString)?.format('h:mmA') || '';
    },

    dbDateToBrokerAssignmentDisplayTime: function (dateString: string) {
        return DateUtility.dbDateToLocalMoment(dateString)?.format('h:mma') || '';
    },

    dbDateToSharedStatusDateTime: function (dateString: string) {
        return DateUtility.dbDateToLocalMoment(dateString)?.format('h:mm A [·] MMM D') || '';
    },

    dbDateToSharingRecordDateTime: function (dateString: string) {
        return DateUtility.dbDateToLocalMoment(dateString)?.format('MMM D, h:mm A') || '';
    },

    dbDateToDispatchOrderHeaderDate: function (dateString: string) {
        return moment(dateString, 'YYYY-MM-DD').format('ddd, MMM D, YYYY') || '';
    },

    dbDateToBrokerPlanTitleDate: function (dateString: string) {
        return DateUtility.urlDateToMoment(dateString).format('dddd, MMMM D')
    },

    dbDateToBrokerShareMessageDate: function (dateString: string) {
        return DateUtility.urlDateToMoment(dateString).format('ddd, MMM D')
    },

    dbDateToBrokerPlanGeneratedDateTime: function (dateString: string) {
        return DateUtility.dbDateToLocalMoment(dateString)?.format('MMM D, YYYY [at] h:mm A') || '';
    },

    dbDateToCompactDisplayDate: function (dateString: string) {
        return DateUtility.urlDateToMoment(dateString).format('dd, MMM D')
    },

    dbDateToCompactDisplayDateWithYear: function (dateString: string) {
        return DateUtility.urlDateToMoment(dateString).format('dd, MMM D, YYYY')
    },

    dbDateRangeToCompactDisplayRange: function (startDateString: string, endDateString: string) {
        return `${DateUtility.dbDateToCompactDisplayDate(startDateString)} - ${DateUtility.dbDateToCompactDisplayDate(endDateString)}`
    },

    dbDateToRequestedDisplayDate: function (dateString: string) {
        return DateUtility.momentToRequestedDisplayDate(DateUtility.dbDateToLocalMoment(dateString))
    },

    momentToRequestedDisplayDate: function (momentIn?: moment.Moment) {
        return momentIn?.format('h:mma M/D/YY') || '';
    },

    dbDateToJsDate: function (dateString: string) {
        return DateUtility.dbDateToLocalMoment(dateString)?.toDate()
    },
}
